import Collection from "../../data-structures/collection"
import CustomEntity from "./custom-entity"
import {SortDirection} from "../../data-structures/sort";

export default class CustomEntitiesCollection extends Collection<CustomEntity>{

    constructor(models:CustomEntity[]) {
        super(models);
    }

    static initFromJson(data: any): CustomEntitiesCollection {

        const models: CustomEntity[] = []

        _.map(data, (record: JSONObject)=>{
            models.push(new CustomEntity(record))
        })

        const collection = new CustomEntitiesCollection(models)
        collection.sort()

        return collection
    }

    resetFromJson(records:JSONArray):void {

        const models : CustomEntity[] = []
        _.map(records, (record:JSONObject)=>{
            models.push(new CustomEntity(record))
        })

        this.reset(models)
        this.sort()
    }

    sort() {
        this.models = _.orderBy(this.models, model=>model.name.toLowerCase(), SortDirection.ASC)
    }
}
